import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "vi-tabs" }

import type { TabsPaneContext } from "element-plus";




import { ElTabs } from "element-plus";
import { ElTabPane } from "element-plus";


export default /*@__PURE__*/_defineComponent({
  __name: 'vi-tabs',
  props: {
    onChange: { type: Function },
    selectedTab: {},
    tabs: {}
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const onSelect = (tab: TabsPaneContext) => {
  emit("change", tab.paneName);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ElTabs), {
      class: "vi-tab",
      "model-value": props.selectedTab,
      onTabClick: onSelect
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tabs, (tab) => {
          return (_openBlock(), _createBlock(_unref(ElTabPane), {
            key: tab.id,
            label: tab.label,
            name: tab.id
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(tab.component)))
            ]),
            _: 2
          }, 1032, ["label", "name"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["model-value"])
  ]))
}
}

})